declare namespace $ {

	type $mol_check_box__checked_bog_blitz_admin_editor_1 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['manual_mode'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_labeler__title_bog_blitz_admin_editor_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_blitz_admin_editor_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_number__value_bog_blitz_admin_editor_4 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['time_read'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_labeler__title_bog_blitz_admin_editor_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_blitz_admin_editor_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_number__value_bog_blitz_admin_editor_7 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['time_answer'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_labeler__title_bog_blitz_admin_editor_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_blitz_admin_editor_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_number__value_bog_blitz_admin_editor_10 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['time_reveal'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_labeler__title_bog_blitz_admin_editor_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_blitz_admin_editor_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_number__value_bog_blitz_admin_editor_13 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['time_leaderboard'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_labeler__title_bog_blitz_admin_editor_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_blitz_admin_editor_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_number__value_bog_blitz_admin_editor_16 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['points_base'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_labeler__title_bog_blitz_admin_editor_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_blitz_admin_editor_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_number__value_bog_blitz_admin_editor_19 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['time_multiplier'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_labeler__title_bog_blitz_admin_editor_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_blitz_admin_editor_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string_button__hint_bog_blitz_admin_editor_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_string_button__value_bog_blitz_admin_editor_23 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['quiz_title'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_list__rows_bog_blitz_admin_editor_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_major__title_bog_blitz_admin_editor_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_blitz_admin_editor_26 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['add_question'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $bog_blitz_admin_question__number_bog_blitz_admin_editor_27 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['question_number'] >
		,
		ReturnType< $bog_blitz_admin_question['number'] >
	>
	type $bog_blitz_admin_question__question_text_bog_blitz_admin_editor_28 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['question_text'] >
		,
		ReturnType< $bog_blitz_admin_question['question_text'] >
	>
	type $bog_blitz_admin_question__question_type_bog_blitz_admin_editor_29 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['question_type'] >
		,
		ReturnType< $bog_blitz_admin_question['question_type'] >
	>
	type $bog_blitz_admin_question__delete_bog_blitz_admin_editor_30 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['delete_question'] >
		,
		ReturnType< $bog_blitz_admin_question['delete'] >
	>
	type $bog_blitz_admin_question__option_rows_bog_blitz_admin_editor_31 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['option_rows'] >
		,
		ReturnType< $bog_blitz_admin_question['option_rows'] >
	>
	type $bog_blitz_admin_question__add_option_bog_blitz_admin_editor_32 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['add_option'] >
		,
		ReturnType< $bog_blitz_admin_question['add_option'] >
	>
	type $bog_blitz_admin_question__correct_text_bog_blitz_admin_editor_33 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['correct_text'] >
		,
		ReturnType< $bog_blitz_admin_question['correct_text'] >
	>
	type $bog_blitz_admin_question__question_image_files_bog_blitz_admin_editor_34 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['question_image_files'] >
		,
		ReturnType< $bog_blitz_admin_question['question_image_files'] >
	>
	type $bog_blitz_admin_question__question_image_uri_bog_blitz_admin_editor_35 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['question_image_uri'] >
		,
		ReturnType< $bog_blitz_admin_question['question_image_uri'] >
	>
	type $bog_blitz_admin_question__remove_image_bog_blitz_admin_editor_36 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['remove_question_image'] >
		,
		ReturnType< $bog_blitz_admin_question['remove_image'] >
	>
	type $bog_blitz_admin_option__option_text_bog_blitz_admin_editor_37 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['option_text'] >
		,
		ReturnType< $bog_blitz_admin_option['option_text'] >
	>
	type $bog_blitz_admin_option__is_correct_bog_blitz_admin_editor_38 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['is_correct'] >
		,
		ReturnType< $bog_blitz_admin_option['is_correct'] >
	>
	type $bog_blitz_admin_option__delete_bog_blitz_admin_editor_39 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['delete_option'] >
		,
		ReturnType< $bog_blitz_admin_option['delete'] >
	>
	type $bog_blitz_admin_option__option_image_files_bog_blitz_admin_editor_40 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['option_image_files'] >
		,
		ReturnType< $bog_blitz_admin_option['option_image_files'] >
	>
	type $bog_blitz_admin_option__option_image_uri_bog_blitz_admin_editor_41 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['option_image_uri'] >
		,
		ReturnType< $bog_blitz_admin_option['option_image_uri'] >
	>
	type $bog_blitz_admin_option__remove_image_bog_blitz_admin_editor_42 = $mol_type_enforce<
		ReturnType< $bog_blitz_admin_editor['remove_option_image'] >
		,
		ReturnType< $bog_blitz_admin_option['remove_image'] >
	>
	export class $bog_blitz_admin_editor extends $mol_list {
		editor_rows( ): readonly(any)[]
		quiz_title( next?: string ): string
		manual_mode( next?: boolean ): boolean
		Manual_mode( ): $mol_check_box
		Manual_mode_row( ): $mol_labeler
		time_read( next?: number ): number
		Time_read( ): $mol_number
		Time_read_row( ): $mol_labeler
		time_answer( next?: number ): number
		Time_answer( ): $mol_number
		Time_answer_row( ): $mol_labeler
		time_reveal( next?: number ): number
		Time_reveal( ): $mol_number
		Time_reveal_row( ): $mol_labeler
		time_leaderboard( next?: number ): number
		Time_leaderboard( ): $mol_number
		Time_leaderboard_row( ): $mol_labeler
		points_base( next?: number ): number
		Points_base( ): $mol_number
		Points_base_row( ): $mol_labeler
		time_multiplier( next?: number ): number
		Time_multiplier( ): $mol_number
		Time_multiplier_row( ): $mol_labeler
		add_question( next?: any ): any
		question_number( id: any): number
		question_text( id: any, next?: string ): string
		question_type( id: any, next?: string ): string
		delete_question( id: any, next?: any ): any
		option_rows( id: any): readonly(any)[]
		add_option( id: any, next?: any ): any
		correct_text( id: any, next?: string ): string
		question_image_files( id: any, next?: readonly(any)[] ): readonly(any)[]
		question_image_uri( id: any): string
		remove_question_image( id: any, next?: any ): any
		option_text( id: any, next?: string ): string
		is_correct( id: any, next?: boolean ): boolean
		delete_option( id: any, next?: any ): any
		option_image_files( id: any, next?: readonly(any)[] ): readonly(any)[]
		option_image_uri( id: any): string
		remove_option_image( id: any, next?: any ): any
		quiz_land( ): any
		rows( ): ReturnType< $bog_blitz_admin_editor['editor_rows'] >
		Title_input( ): $mol_string_button
		Settings( ): $mol_list
		Add_question( ): $mol_button_major
		Question( id: any): $bog_blitz_admin_question
		Option( id: any): $bog_blitz_admin_option
	}
	
}

//# sourceMappingURL=editor.view.tree.d.ts.map